import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import "./plugins/ant-design-vue.js";
import "./plugins/use";

window.GLASSON_CONFIG = {
  ENDPOINT: "https://glasson.sk-global.biz/api/v2/",
  STORAGE: "https://production-glasson.s3-ap-northeast-1.amazonaws.com/"
};

Vue.config.productionTip = false;

const store = new Vuex.Store({
  state: {
    options: null,
    selectedOpt: {},
    orderId: null,
    pd: ""
  },
  mutations: {
    putOptions(state, options) {
      state.options = options;
    },
    selectOption(state, option) {
      state.selectedOpt = { ...state.selectedOpt, [option.kind]: option };
    },
    updateOrderId(state, orderId) {
      state.orderId = orderId;
    },
    updatePD(state, pd) {
      state.pd = pd;
    }
  }
});

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
